// extracted by mini-css-extract-plugin
export var imageWrapper = "metamorphosis-module--image-wrapper--da31a";
export var textWrapper = "metamorphosis-module--text-wrapper--024be";
export var wrapper = "metamorphosis-module--wrapper--a05a7";